import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { CopyText } from "../CopyText";

import styles from "./TextImageTeaser.scss";

const TeaserCopyText = forwardRef(({ children, variants, ...others }, ref) => {
  const copyTextClasses = classNames(styles.teaserCopyText, variants);
  return (
    <CopyText className={copyTextClasses} ref={ref} {...others}>
      {children}
    </CopyText>
  );
});

const Variant = {
  xl: {
    quaternary: styles.copyXlQuaternary,
    copy: styles.copyXl,
  },
  l: {
    quaternary: styles.copyLQuaternary,
    copy: styles.copyL,
  },
  sm: {
    copy: styles.copySm,
  },
};

TeaserCopyText.Variant = Variant;

TeaserCopyText.propTypes = {
  children: PropTypes.node.isRequired,
  variants: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

TeaserCopyText.defaultProps = {
  variants: [Variant.xl.quaternary, Variant.l.quaternary, Variant.sm.copy],
};

TeaserCopyText.displayName = "TextImageTeaser.CopyText";

export default TeaserCopyText;
